<template>
  <div v-if="showNotice" class="player-notice-box">
    <h3>
      <!--
        player-notice-button player-notice-open
        player-notice-button player-notice-close
      -->
      <button type="button" :class="getButtonClass" @click.prevent="toggleDetail">
        <span class="player-notice-icon">공지사항</span>
        <span class="player-notice-title-text">{{notice.title}}</span>
      </button>
    </h3>
    <div class="player-notice-content" v-if="showDetail">
      <span class="player-notice-content-date">{{notice.noticedate}}</span>
      <p v-html="replaceReturnMarkup(notice.description)"></p>
    </div>
  </div>
</template>
<script>
import { getProgramNotice } from '@/common/utils/request'
import _ from 'lodash'

export default {
  name: 'PlayerNotice',
  props: {
    contentId: {
      type: String
    }
  },
  data () {
    return {
      showNotice: false,
      showDetail: false,
      notice: null
    }
  },
  computed: {
    getButtonClass () {
      return this.showDetail
        ? 'player-notice-button player-notice-close'
        : 'player-notice-button player-notice-open'
    },
    description () {
      return _.get(this.notice, 'description', '').replace(/\n/gi, '<br>')
    }
  },
  methods: {
    setData () {
      getProgramNotice(this.contentId).then(({ data }) => {
        const list = _.get(data, 'list', [])
        if (list.length > 0) {
          this.notice = list[0]
          this.showNotice = _.get(list, ['0', 'status'], 'N').toUpperCase() === 'Y'
        }
      })
    },
    toggleDetail () {
      this.showDetail = !this.showDetail
    },
    replaceReturnMarkup (text = '') {
      return text.replace(/\n/gi, '<br>')
    }
  },
  created () {
    this.setData()
  }
}
</script>
<style>

</style>
